import { BaseAdmin, BaseCompany } from "./bases/base.service";
import type { CompanyState } from "@/store/company/types";

export default class CompanyService {
    public getMasterJobs(params: any = {}) {
        return BaseAdmin().get<ServerResponse<CompanyState['masterJobs']>>("admin-job-fair/landing/company/get-master-job-landing", { params });
    }
}
